// extracted by mini-css-extract-plugin
export var icon = "_4r-3";
export var subtitle = "_4r-2";
export var title = "_4r-1";
export var value = "_4r-0";